module.exports = __webpack_public_path__ + "img/small-electric-pole.f62fee51.png";